module.exports = __webpack_public_path__ + "static/img/banner10.efa70b5c.png";